'use client';

import { Shield } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CertifiedCopyBadgeProps {
  compact?: boolean;
  className?: string;
}

export function CertifiedCopyBadge({
  compact = false,
  className
}: CertifiedCopyBadgeProps) {
  const baseClasses = 'inline-flex items-center gap-1.5 rounded bg-info-subtle';
  const borderClasses = compact ? '' : 'border border-info/20';
  const paddingClasses = compact ? 'px-2' : 'px-2 py-1';

  return (
    <div className={cn(baseClasses, borderClasses, paddingClasses, className)}>
      <Shield className="text-info-subtle-foreground h-3 w-3" />
      <span className="text-info-subtle-foreground text-xs font-medium">
        Certified Copy
      </span>
    </div>
  );
}
